import { Source, Thoughts, V2Source } from "../api";

export interface ToolCallStatus {
    callId: string;
    toolName: string;
    status: "running" | "completed";
    arguments?: string;
    resultSummary?: string;
    failed?: boolean;
}

export interface Tooltip {
    title: string;
    cloudinaryID: string;
    mediaType: string;
    publicationId: string | null;
    publicationUrl: string | null;
    interestAreas: string;
    category: string;
    score: number;
    referenceNumber: string;
    rerankerScore: number;
    lastModifiedTimestamp: Date | null;
    thumbnailUrl: string;
}

export interface Citation {
    title: string;
    footnoteNumber: number;
    path: string;
    sourceFile: string;
    tooltip: Tooltip;
    mergedChunks: boolean;
    score: number;
    rerankerScore: number;
    lastModifiedTimestamp: string | null;
    thumbnailUrl: string;
    source: Source;
}

// this is just for development support
export interface ThoughtProcessData extends Thoughts {}

export interface SupportingContentData {
    data: { title: string; content: string }[];
}
export interface DevelopmentSupportData {
    sources: V2Source[];
    thoughtProcessData: ThoughtProcessData[];
    supportingContent: SupportingContentData;
}
//
export interface Response {
    conversationId: string;
    text: string;
    phiDetected: boolean;
    citations: Citation[];
    followupQuestions: string[];
    toolCalls?: ToolCallStatus[];
    // developmentSupportData is just for development and debugging purposes
    developmentSupportData?: DevelopmentSupportData;
}

export interface Answer {
    userMessage: string;
    response: Response | undefined;
}

export enum FeedbackType {
    Like = "like",
    Dislike = "dislike"
}
